// HOME OPERACIONAL por rol (v2.14.0). Única regla de aterrizaje tras el login.
// · Monitorista interna residencial -> RADAR OPERATIVO (conciencia situacional de su cartera).
// · Monitorista/administración INSTITUCIONAL (external) -> RADAR OPERATIVO · INSTITUCIONAL de su
//   centro: si tiene exactamente UN sitio autorizado entra directo a ese centro (sin selector
//   inútil); con varios, al selector scoped; con cero, al empty state seguro del selector.
//   Los sitios vienen de `effective_site_ids`, que el backend ya calcula como
//   grant ∩ sitios de su organización (tenancy.effective_site_ids). No se amplía ningún permiso
//   ni se consulta nada global: si el arreglo llega vacío, NO hay fallback.
// · Supervisor/Admin interno -> Central, como hasta ahora.
// Central sigue siendo donde se atiende: el Radar sólo es el punto de partida.
import { capacidades } from "@/lib/capacidades";

export function homeDe(user) {
  const caps = capacidades(user);
  if (caps.externo) {
    const sitios = (user && user.effective_site_ids) || [];
    return sitios.length === 1 ? `/centro-v3/${sitios[0]}` : "/centro-v3";
  }
  return caps.interno && !caps.supervisor ? "/centro-v3" : "/consola-v3";
}
